/**
 * رسائل واتساب — تجميع القطع حسب السيارة/الموديل + بيانات العميل.
 */

export function normalizeImageUrlForWhatsApp(url) {
  if (!url || typeof url !== 'string') return '';
  if (typeof window === 'undefined') return url;
  return url.replace(/^https?:\/\/localhost(:\d+)?/, window.location.origin);
}

export function collectItemImageUrls(item) {
  const urls = [];
  if (item.image_url) urls.push(normalizeImageUrlForWhatsApp(item.image_url));
  const extra = item.extra_image_urls;
  if (Array.isArray(extra)) {
    extra.forEach((u) => {
      if (u) urls.push(normalizeImageUrlForWhatsApp(u));
    });
  }
  return [...new Set(urls.filter(Boolean))];
}

export function vehicleTitleFromItem(item) {
  const m = item.modelName || item.model_name || '';
  const v = item.variantName || item.variant_name || '';
  if (m && v) return `${m} — ${v}`;
  if (m) return m;
  if (v) return v;
  return 'بدون تحديد سيارة';
}

function appendItemDetailLines(text, item) {
  const name = item.name_ar || item.name || '-';
  text += `• *${name}*\n`;
  if (item.part_number != null && item.part_number !== '') {
    text += `  رقم القطعة: ${item.part_number}\n`;
  }
  text += `  الكمية: ${item.quantity || 1}\n`;
  if (item.price != null && item.price !== '') {
    text += `  السعر: ${item.price} د.ل\n`;
  }
  const imgs = collectItemImageUrls(item);
  if (imgs.length === 0) {
    text += '  رابط الصورة: —\n';
  } else if (imgs.length === 1) {
    text += `  رابط الصورة: ${imgs[0]}\n`;
  } else {
    imgs.forEach((u, i) => {
      text += `  رابط صورة ${i + 1}: ${u}\n`;
    });
  }
  text += '\n';
  return text;
}

/**
 * تجميع حسب سيارة كل بند (modelName/variantName على العنصر).
 * @param {object} customer { phone?, address? }
 */
export function buildWhatsAppOrderText(items, customer = {}) {
  const groups = new Map();
  for (const item of items || []) {
    const title = vehicleTitleFromItem(item);
    if (!groups.has(title)) groups.set(title, []);
    groups.get(title).push(item);
  }

  let text = '*طلب*\n';
  text += '---------------------\n\n';

  if (customer.phone) {
    text += `*الهاتف:* ${customer.phone}\n`;
  }
  if (customer.address) {
    text += `*العنوان:* ${customer.address}\n`;
  }
  if (customer.phone || customer.address) {
    text += '\n';
  }

  for (const [title, groupItems] of groups) {
    text += `*${title}*\n\n`;
    for (const item of groupItems) {
      text = appendItemDetailLines(text, item);
    }
    text += '\n';
  }

  text += '---------------------\n';
  const totalPrice = (items || []).reduce(
    (sum, i) => sum + (Number(i.price) || 0) * (i.quantity || 1),
    0
  );
  if (totalPrice > 0) {
    text += `*الإجمالي: ${totalPrice.toFixed(2)} د.ل*\n`;
  }
  return text;
}

/** تحويل عناصر السلة لجسم API الطلبات */
export function cartItemsToOrderPayload(items) {
  return (items || []).map((i) => ({
    id: i.id,
    model_name: i.modelName || i.model_name || '',
    variant_name: i.variantName || i.variant_name || '',
    name_ar: i.name_ar || '',
    name: i.name || '',
    part_number: i.part_number || '',
    quantity: i.quantity || 1,
    price: i.price != null && i.price !== '' ? i.price : null,
    image_url: i.image_url || '',
  }));
}

/** دمج سيارة السلة مع حقول القطعة */
export function mergeVehicleForPart(cartVehicle, sparePart) {
  if (cartVehicle && (cartVehicle.modelName || cartVehicle.variantName)) {
    return { ...cartVehicle };
  }
  return {
    modelName: sparePart?.model_name || '',
    variantName: sparePart?.variant_name || '',
  };
}

/** رابط واتساب لرقم عميل (بدون نص مسبق) */
export function whatsappUrlForCustomerPhone(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return null;
  return `https://wa.me/${digits}`;
}
